import { lineItemTestID } from 'components/MerchantTrackingWidget/constants';
import {
  DescriptionColumn,
  DescriptionRow,
  DescriptionTitle,
  DescriptionValue,
  TruncatedTitle,
} from '../../ItemCommons';
import {
  DescriptionHyperLink,
  QuantityPriceWrapper,
} from './CardDetails.styles';
import { Option } from '../../ItemCommons/CommonItem.hook';

interface CardDetailsProps {
  isTileView: boolean;
  isShowDetails: boolean;
  productName: string;
  additionalInformation?: string;
  productQuantity?: Option;
  productPrice?: Option;
  productUrl?: Option<string>;
  productDescription?: Option;
  productReasonForReturn?: Option<string>;
  productCustomReasonForReturn?: Option<string>;
  productID?: Option<string>;
}

export const CardDetails = ({
  isTileView,
  isShowDetails,
  productName,
  productQuantity,
  productPrice,
  productUrl,
  productDescription,
  productReasonForReturn,
  productCustomReasonForReturn,
  additionalInformation,
  productID,
}: CardDetailsProps): JSX.Element => {
  const listBottomMargin = !isShowDetails ? 8 : 4;
  const tileBottomMargin = 8;
  const bottomMargin = isTileView ? tileBottomMargin : listBottomMargin;

  return (
    <>
      <DescriptionRow
        bottomMargin={bottomMargin}
        data-testid={`${lineItemTestID}-name`}
      >
        <TruncatedTitle isShowFull={isShowDetails}>
          {productName}
        </TruncatedTitle>
      </DescriptionRow>
      <QuantityPriceWrapper>
        {productPrice && (
          <DescriptionRow
            gap={4}
            bottomMargin={bottomMargin}
            data-testid={`${lineItemTestID}-price`}
          >
            <DescriptionValue>{`${productPrice.label}: ${productPrice.value}`}</DescriptionValue>
          </DescriptionRow>
        )}
        {productQuantity && (
          <DescriptionRow
            gap={4}
            bottomMargin={bottomMargin}
            data-testid={`${lineItemTestID}-quantity`}
          >
            <DescriptionValue>{productQuantity.value}</DescriptionValue>
          </DescriptionRow>
        )}
      </QuantityPriceWrapper>
      {productID && (
        <DescriptionRow
          gap={4}
          bottomMargin={bottomMargin}
          data-testid={`${lineItemTestID}-id`}
        >
          <DescriptionValue>{`${productID.label}: ${productID.value}`}</DescriptionValue>
        </DescriptionRow>
      )}
      {additionalInformation && (
        <DescriptionRow
          gap={4}
          bottomMargin={bottomMargin}
          data-testid={`${lineItemTestID}-additional-information`}
        >
          <DescriptionValue>{additionalInformation}</DescriptionValue>
        </DescriptionRow>
      )}
      {isShowDetails && (
        <>
          {productReasonForReturn && (
            <DescriptionColumn
              gap={4}
              bottomMargin={bottomMargin}
              data-testid={`${lineItemTestID}-reason-for-return`}
            >
              <DescriptionTitle>
                {productReasonForReturn.label}:
              </DescriptionTitle>
              <DescriptionValue>
                {productReasonForReturn.value}
              </DescriptionValue>
            </DescriptionColumn>
          )}
          {productCustomReasonForReturn && (
            <DescriptionColumn
              gap={4}
              bottomMargin={bottomMargin}
              data-testid={`${lineItemTestID}-custom-reason-for-return`}
            >
              <DescriptionTitle>
                {productCustomReasonForReturn.label}:
              </DescriptionTitle>
              <DescriptionValue>
                {productCustomReasonForReturn.value}
              </DescriptionValue>
            </DescriptionColumn>
          )}
          {productDescription && (
            <DescriptionColumn
              gap={4}
              bottomMargin={bottomMargin}
              data-testid={`${lineItemTestID}-description`}
            >
              <DescriptionTitle>{productDescription.label}:</DescriptionTitle>
              <DescriptionValue>{productDescription.value}</DescriptionValue>
            </DescriptionColumn>
          )}
          {productUrl && (
            <DescriptionHyperLink
              bottomMargin={16}
              href={productUrl.value}
              target="_blank"
              aria-label={`${productUrl.label} ${productName}`}
              data-testid={`${lineItemTestID}-url`}
            >
              {productUrl.label}
            </DescriptionHyperLink>
          )}
        </>
      )}
    </>
  );
};
